/*
 * @fileOverView Checkbox component definition
 *
 * Currently only useful when a parent needs to respond to a changed value.
 */

import Vue from 'vue';

/**
 * [Checkbox Vue]
 * @type {class}
 */
Vue.component('checkbox-vue', {
  data: function() {
    return {
      value: false
    }
  },

  watch: {
    value: function() {
      this.$emit('checkbox-changed', this.value, this.$el);
    }
  },

  methods: {
    /**
     * Handles the change of the checkbox form element.
     */
    handleClick: function (e) {
      this.value = e.target.checked;
    },

    /**
     * Resets the element to the default value.
     *
     * Exists to be used by parent elements, such as filters.
     */
    reset() {
      this.set(false);
    },

    /**
     * Set the element to a specific value.
     *
     * Exists to be used by parent elements, such as filters.
     *
     * @param {Boolean} value
     *   The value to set the element to.
     */
    set(value) {
      this.value = value;
      this.$refs.input.checked = this.value;
    }
  }
})
